import { render, staticRenderFns } from "./choice-content.vue?vue&type=template&id=655b08a2&scoped=true&"
import script from "./choice-content.vue?vue&type=script&lang=js&"
export * from "./choice-content.vue?vue&type=script&lang=js&"
import style0 from "./choice-content.vue?vue&type=style&index=0&id=655b08a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b08a2",
  null
  
)

export default component.exports